import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useApi } from "~hooks/apiHooks/useApi";
import type { FixtureResponse } from "~types/fixture";

type TransformFn<T> = (data: FixtureResponse) => T;

export const useFetchSeasonFixtures = <TTransformedData = FixtureResponse>(
  urlParams: Record<string, string>,
  transformFn: TransformFn<TTransformedData> = (data) => data as unknown as TTransformedData,
  options: Omit<UseQueryOptions<TTransformedData>, "queryKey" | "queryFn"> = {},
) => {
  const request = useApi();

  const { organizationId, sport, seasonId } = useParams();

  if (!organizationId || !sport || !seasonId) {
    throw new Error(
      `OrganizationId, sport or seasonId not found in route params. organizationId: ${organizationId}, sport: ${sport}, seasonId: ${seasonId}`,
    );
  }

  const params = new URLSearchParams(urlParams);

  return useQuery({
    queryKey: ["fixtures", sport, organizationId, seasonId, params.toString()],
    queryFn: () =>
      request<FixtureResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/fixtures?${params.toString()}`).then(transformFn),
    ...options,
  });
};
